import { render, staticRenderFns } from "./AttributeSelection.vue?vue&type=template&id=464d3d51&"
import script from "./AttributeSelection.vue?vue&type=script&lang=js&"
export * from "./AttributeSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\dev.marcdeloche.fr\\themes\\marcdeloche\\_dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('464d3d51', component.options)
    } else {
      api.reload('464d3d51', component.options)
    }
    module.hot.accept("./AttributeSelection.vue?vue&type=template&id=464d3d51&", function () {
      api.rerender('464d3d51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/vuejs/components/Product/AttributeSelection.vue"
export default component.exports